import { Stack } from "@mui/material";
import { Box } from "@mui/system";
import { TimeLeft } from "components/DateTime/TimeLeft";
import { TimeSince } from "components/DateTime/TimeSince";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import DoneIcon from "@mui/icons-material/Done";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import { LabelChip } from "components/Chip/LabelChip";

export const TaskMeta = ({
  taskDetails,
  taskToName,
  taskByName,
  taskToOn,
  acceptanceStatus,
  acceptanceOn,
  deadline,
  doneStatus,
  doneOn,
  acknowledgeStatus,
  acknowledgeOn,
}) => {
  return taskDetails ? (
    <>
      <FlexBox>
        <Box>{`Task - ${taskDetails}`}</Box>
      </FlexBox>
      <Stack direction="row" flexWrap="wrap" alignItems="center">
        <LabelChip
          label="By"
          value={taskByName}
          icon={<PersonIcon sx={{ fontSize: 16 }} />}
        />
        <LabelChip
          label="To"
          value={taskToName || "None"}
          icon={<PersonIcon sx={{ fontSize: 16 }} />}
        />
        <LabelChip
          label="Assigned"
          value={
            <TimeSince startDate={taskToOn} variant="data" fontSize={11} />
          }
          icon={<AccessTimeIcon sx={{ fontSize: 16 }} />}
        />
        {acceptanceStatus === "ACCEPTED" && acceptanceOn && (
          <LabelChip
            label="Accepted"
            value={
              <TimeSince
                startDate={acceptanceOn}
                variant="data"
                fontSize={11}
              />
            }
            icon={<DoneIcon sx={{ fontSize: 16 }} />}
          />
        )}
        <LabelChip
          label="Deadline"
          value={
            <TimeLeft targetDate={deadline} variant="data" fontSize={11} />
          }
          icon={<EventAvailableIcon sx={{ fontSize: 16 }} />}
        />
        {doneStatus && (
          <LabelChip
            label="Done"
            value={
              <TimeSince startDate={doneOn} variant="data" fontSize={11} />
            }
            icon={<DoneIcon sx={{ fontSize: 16 }} />}
          />
        )}{" "}
        {acknowledgeStatus && (
          <LabelChip
            label="Acknowledged"
            value={
              <TimeSince
                startDate={acknowledgeOn}
                variant="data"
                fontSize={11}
              />
            }
            icon={<DoneIcon sx={{ fontSize: 16 }} />}
          />
        )}
      </Stack>
    </>
  ) : (
    ""
  );
};
